<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        v-if="!editable && editMode"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Qualifications summary') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <form v-on:submit.prevent="save(candidateEdit)">
        <div class="form-group">
          <textarea-autosize
            v-model="candidateEdit.summary"
            :min-height="80"
            class="form-control">
            </textarea-autosize>
          <ValidateMessage :error="validateErrors.summary" />
        </div>
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>
    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
      <span style="white-space: pre-wrap;">{{ candidate.summary }}</span>
    </div>
  </div>

</template>

<script>
import _ from 'lodash'

export default {
  name: 'CandidateProfileCoverLetter',
  components: {
  },
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  props: [
    'editMode'
  ],
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    filled () {
      return this.candidate.summary
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = _.pick(this.candidate, [
        '_id',
        'summary'
      ])
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileCoverLetter.vue